import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Switch } from '@algoacademy/design-system/web/forms/Switch';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import { cn } from '@/app/_lib/utils';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
type CareerCoachingProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: (prev: AdvancedMentoringProductDTO) => Partial<AdvancedMentoringProductDTO>) => void;
};
export function CareerCoaching(t0) {
  const $ = _c(12);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const customizedTasks = advancedMentoringProduct.careerCoaching;
  const t1 = !customizedTasks && "text-slate-400";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <H4 className="font-medium">Premium career coaching</H4>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = customizedTasks === 1;
  let t5;
  if ($[3] !== updateProduct) {
    t5 = () => updateProduct(_temp);
    $[3] = updateProduct;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <div className="flex items-center justify-between">{t3}<Switch checked={t4} onChange={t5} /></div>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <P2 className="text-contentSecondary">Opcja stworzona dla pracujących w branży IT, którzy chcą wyjść na wyższy poziom w swojej karierze. Networking, budowanie marki osobistej, optymalizacja CV i profili LinkedIn/GitHub, kształtowanie umiejętności prezentacji i zarządzania zespołem.</P2>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t2 || $[10] !== t6) {
    t8 = <IconOnTheLeftWithContentLayout className={t2} mainContent={t6}>{t7}</IconOnTheLeftWithContentLayout>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(prev) {
  return {
    careerCoaching: prev.careerCoaching === 1 ? 0 : 1
  };
}